import React from 'react';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import { SideDrawerContentContainer } from '../../../../../v2BaseComponents/SideDrawer';
import InvitationDefinitionDetails from '../../../../../shared/InvitationDefinitions/InvitationDefinitionDetails';
import useOrganizationInvitationDefinitions from '../../../../../../hooks/api/useOrganizationInvitationDefinitions';

export type InvitationDefinitionDetailsDrawerContentOwnProps = {
    invitationDefinitionId: string;
};

export type InvitationDefinitionDetailsDrawerContentProps = InvitationDefinitionDetailsDrawerContentOwnProps;

const InvitationDefinitionDetailsDrawerContent: React.FC<InvitationDefinitionDetailsDrawerContentProps> = ({
    invitationDefinitionId,
}) => {
    const { isLoadingInvitationDefinition, invitationDefinition } = useOrganizationInvitationDefinitions({
        invitationDefinitionId: invitationDefinitionId,
    });

    return (
        <AnimateLoadedContent isLoading={isLoadingInvitationDefinition || !invitationDefinition}>
            {() => (
                <SideDrawerContentContainer>
                    <InvitationDefinitionDetails invitationDefinitionId={invitationDefinitionId} />
                </SideDrawerContentContainer>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(InvitationDefinitionDetailsDrawerContent);
